// Configurazione Development
export const developmentConfig = {
  // ENV: 'development',
  // API_URL: 'http://localhost:5010',
  // API_URL_V1: 'http://localhost:8000',
  // DEBUG: true,
  // TIMEOUT: 30000,
  ENV: 'production',
  API_URL: 'https://musea.agilae.it/human',
  API_URL_V1: 'https://musea.agilae.it/be',
  DEBUG: false,
  TIMEOUT: 30000,
}; 